// Hardcoded feature request data for OctopusSync
export const octopusSyncFeatures = [
  {
    date: '2025-05-17',
    feature: 'Approval',
    description: 'Manual of approval of positions',
    details: 'Allows manual approval of trading positions before execution.',
    beta: '',
    release: '2025-05-17',
  },
  {
    date: '2025-03-15',
    feature: 'ByBit',
    description: 'Integration with ByBit',
    details: 'Integrates OctopusSync with ByBit exchange for seamless trading.',
    beta: '',
    release: '',
  },
  {
    date: '2025-02-14',
    feature: 'Binance',
    description: 'Integration with Binance',
    details: 'Integrates OctopusSync with Binance exchange for seamless trading.',
    beta: '',
    release: '',
  },
  {
    date: '2025-02-14',
    feature: 'Delayed execution',
    description: 'Delayed execution of positions',
    details: 'Allows delayed execution of trading positions for advanced strategies.',
    beta: '2025-02-07',
    release: '2025-02-14',
  },
  {
    date: '2025-01-27',
    feature: 'Sockets API',
    description: 'Real-Time communications',
    details: 'Enables real-time communication via sockets for fast data transfer.',
    beta: '2025-01-20',
    release: '2025-01-27',
  },
  {
    date: '2024-08-23',
    feature: 'HFT mode',
    description: 'Additional speed boost for HFT strategies',
    details: 'Provides extra speed for high-frequency trading strategies.',
    beta: '2024-08-16',
    release: '2024-08-23',
  },
  {
    date: '2024-05-26',
    feature: 'Match Trader integration',
    description: 'Copy trades between Match Trader and other platforms',
    details: 'Allows copying trades between Match Trader and other supported platforms.',
    beta: '',
    release: '',
  },
  {
    date: '2024-08-23',
    feature: 'Trading terminal',
    description: 'Manage trades directly on MetaCopier',
    details: 'Enables direct trade management on MetaCopier terminal.',
    beta: '2024-08-16',
    release: '2024-08-23',
  },
  {
    date: '2024-08-23',
    feature: 'TP/SL Management',
    description: 'Control TP/SL settings',
    details: 'Allows control of Take Profit and Stop Loss settings.',
    beta: '2024-08-16',
    release: '2024-08-23',
  },
  {
    date: '2024-11-01',
    feature: 'Signal sharing',
    description: 'Share signals with other users',
    details: 'Enables sharing of trading signals with other users.',
    beta: '2024-10-25',
    release: '2024-11-01',
  },
  {
    date: '2024-05-26',
    feature: 'Daily profit target',
    description: 'Add a daily target to limit risks',
    details: 'Lets users set daily profit targets to manage risk.',
    beta: '2024-05-19',
    release: '2024-05-26',
  },
  {
    date: '2024-08-23',
    feature: 'Dedicated IP',
    description: 'Dedicated IPs for your accounts',
    details: 'Provides dedicated IP addresses for user accounts.',
    beta: '2024-08-16',
    release: '2024-08-23',
  },
];
